import React, { useEffect, useState } from "react";
import axios from "axios";
import { chunk } from "lodash";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import enTranslations from "../../translations/en";
import useEbsApiClient from "../../hooks/useEbsApiClient.js";
import { loadFollowerAssets } from "../../lib/follower-loader.js";
import { getVariationImagesMap } from "../../lib/follower-variations-renderer.js";

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    // the translations
    // (tip move them in a JSON file and import them,
    // or even better, manage them via a UI: https://react.i18next.com/guides/multiple-translation-files#manage-your-translations-with-a-management-gui)
    resources: {
      en: {
        translation: enTranslations,
      },
    },
    lng: "en", // if you're using a language detector, do not define the lng option
    fallbackLng: "en",

    interpolation: {
      escapeValue: false, // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
    },
  });

const ExtensionWrapper = ({ children }) => {
  const [isInitialised, setIsInitialised] = useState(false);
  const ebsApiClient = useEbsApiClient();

  const generateVariationPreviews = async () => {
    const { getVariationImagesMap } = await import(
      "../../lib/follower-variations-renderer.js"
    );

    const variationsResponse = await ebsApiClient.get(
      "/followers/variations?all=true"
    );

    console.time("getVariationImagesMap");
    window.variationImages = getVariationImagesMap(
      variationsResponse.data.variations
    );
    console.timeEnd("getVariationImagesMap");

    console.time("render variation images");
    const chunks = chunk(Object.entries(window.variationImages), 50);
    for await (const chunk of chunks) {
      await axios.post(
        "http://localhost:1337/render",
        Object.fromEntries(chunk)
      );
    }
    console.timeEnd("render variation images");
  };

  useEffect(() => {
    (async () => {
      await loadFollowerAssets();
      //generateVariationPreviews();
      setIsInitialised(true);
    })();
  }, []);

  if (!isInitialised) {
    return null;
  }

  return children;
};

export default ExtensionWrapper;
